import React, { useState, useRef, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useSetAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import classNames from 'classnames/bind';

import QuitRemindPopup from '@/components/CustomTravel/QuitRemindPopup';
import { customTravelFormStateAtom } from '@/atoms/customTravelFormState';
import { env } from '@/lib/env';
import { customTravelScrollElementAtom } from '@/atoms/layout';

import styles from './CustomTravelLayout.module.scss';

interface CustomTravelLayoutProps {
  children?: React.ReactNode;
}

const cx = classNames.bind(styles);

function getIsEstimateRequestProcess(path: string) {
  return [
    '/custom-travel/[agtName]/[productId]',
    '/custom-travel/[agtName]/[productId]/estimate',
    '/custom-travel/[agtName]/[productId]/consulting',
  ].includes(path);
}

const CustomTravelLayout: React.FC<CustomTravelLayoutProps> = ({ children }) => {
  const router = useRouter();
  const resetFormState = useResetAtom(customTravelFormStateAtom);

  const setCustomTravelScrollElement = useSetAtom(customTravelScrollElementAtom);
  const customTravelScrollElementRef = useRef<HTMLDivElement>(null);

  const [isShowRemindPopup, setIsShowRemindPopup] = useState(false);

  const isEstimateRequestProcess = getIsEstimateRequestProcess(router.pathname);

  const handleOpenRemindClosePopup = () => {
    setIsShowRemindPopup(true);
  };

  const handleClosePopup = () => {
    setIsShowRemindPopup(false);
  };

  const handleClickClose = () => {
    const { agtName, productId } = router.query;
    if ((!agtName || !productId) && env('MY_PAGE_URL')) {
      window.location.href = `${env('MY_PAGE_URL')}/consultations/pkgtours`;
      return;
    }
    const targetUrl = env('VERTICAL_SERVICE_URL');
    const targetPath = `/products/${agtName}/${productId}`;

    if (typeof window !== 'undefined') {
      window.location.href = `${targetUrl}${targetPath}`;
    }
  };

  useEffect(() => {
    if (customTravelScrollElementRef.current) {
      setCustomTravelScrollElement(customTravelScrollElementRef.current);
    }
    return () => {
      resetFormState();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className={cx('CustomContainer')}>
        <div className={cx('head')}>
          <span className={cx('title')}>단체여행 신청</span>
          <button
            type="button"
            className={cx('close')}
            aria-label="닫기"
            onClick={isEstimateRequestProcess ? handleOpenRemindClosePopup : handleClickClose}
            data-event-nlog="click"
            data-event-area-code="cus.reqclosepage"
          />
        </div>
        <div className={cx('content')}>
          <div className={cx('inner')} ref={customTravelScrollElementRef}>
            {children}
            {isShowRemindPopup && <QuitRemindPopup onCancel={handleClickClose} onContinue={handleClosePopup} />}
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomTravelLayout;
